import { createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import { NavigationState } from './types';
import { NAVIGATION_WEB_STATE_CHANGE, NAVIGATION_BREAD_CRUMBS } from './actions.web';

export const navigationState: NavigationState = {
  breadCrumbs: []
};

const navigationReducer = createReducer<NavigationState>(navigationState, {
  [NAVIGATION_BREAD_CRUMBS]: (state, action) => {
    if (action.payload.breadCrumbs.length <= 0) return;
    state.breadCrumbs = [action.payload.breadCrumbs, ...state.breadCrumbs];
  },
  [NAVIGATION_WEB_STATE_CHANGE]: (state, action) => {
    state.webState = action.payload.webState;
  },
  [switchAccountSuccess.type]: () => ({ ...navigationState, webState: 'authenticated' })
});

export default navigationReducer;
